// extracted by mini-css-extract-plugin
module.exports = {"matchingTable":"MatchingTable_matchingTable__2lo72"};